import useCaptureException from "@/components/vendors/monitoring/use-capture-exception";
import Errors from "./errors";

export default function UnexpectedError({ error }) {
  useCaptureException(error);
  return (
    <Errors
      title="Oops! Something Went Wrong"
      description="An unexpected error occurred."
    >
      <>
        <ul className="mb-5 list-disc pl-5 text-sm text-gray-700">
          <li>
            Try refreshing the page or{" "}
            <a href="/" className="underline">
              returning to the homepage.
            </a>{" "}
          </li>
          <li>
            If the issue persists, please{" "}
            <a href="/" className="underline">
              contact support
            </a>{" "}
            and let us know what happened.
          </li>
        </ul>
        <p className="text-sm text-gray-700">
          We apologize for the inconvenience and appreciate your patience.
        </p>
      </>
    </Errors>
  );
}
